import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {  
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'chanel_address', 'chanel_name', 'chanel_typeid', 'chanel_typename', 'chanel_catid', 'chanel_catname', 'chanel_vendor_id', 'pemilik'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/amgchanel${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listLines(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/amgchanel/lines/${obj.channelId}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    deal(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'chanel_address', 'chanel_name', 'chanel_typeid', 'chanel_typename', 'chanel_catid', 'chanel_catname', 'chanel_vendor_id', 'pemilik'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/amgchanel/deal${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/amgchanel', obj);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/amgchanel/${obj.IdPRHeader}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/amgchanel/detail/${obj._id}`);
                console.log('data >>',data);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
        try {
            const keys = ['sortBy', 'sortDir', 'chanel_address', 'chanel_name', 'chanel_typeid', 'chanel_typename', 'chanel_catid', 'chanel_catname', 'chanel_vendor_id', 'pemilik'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const response = axios({
                url: `/amgchanel/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            });
            resolve(response);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},    
attachmentDownload(obj) {
    return new Promise((resolve, reject) => {
        try {
            axios({
                url: `/amgchanel-attachment/${obj.salesHdrKey}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', obj.attchFileNm);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
},

};